import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
import { recentBuyers } from '../data/content';
import { OFFER_ANCHOR } from '../data/config';
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const reduce = useReducedMotion();
  useEffect(() => {
    if (dismissed) return;
    let timer: ReturnType<typeof setTimeout>;
    const show = () => {
      setVisible(true);
      timer = setTimeout(hide, 5000);
    };
    const hide = () => {
      setVisible(false);
      timer = setTimeout(() => {
        setIndex(i => (i + 1) % recentBuyers.length);
        show();
      }, 8000);
    };
    timer = setTimeout(show, 4000);
    return () => clearTimeout(timer);
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <div className="pointer-events-none fixed bottom-3 left-3 z-50 w-[240px] sm:bottom-4 sm:left-4" aria-live="polite" data-id="element-189" data-mp="1gwufeb0wwgi7">
      <AnimatePresence data-id="element-190" data-mp="117frg5fx9zsx">
        {visible && !dismissed && <motion.div key={buyer.name} initial={reduce ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 14,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={reduce ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 10
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative" data-id="element-191" data-mp="114tj43l7jg9n">
            <a href={OFFER_ANCHOR} className="flex items-start gap-2.5 rounded-lg border border-gold/50 bg-white px-3 py-2 shadow-popup" data-id="element-192" data-mp="i9v08rpoqp55">
              <span className="mt-0.5 flex h-[20px] w-[20px] shrink-0 items-center justify-center rounded-full bg-check" data-id="element-193" data-mp="s5ewxgc2pruy">
                <CheckIcon className="h-3 w-3 text-white" strokeWidth={4} aria-hidden data-id="element-194" data-mp="28mkhnucilx84" />
              </span>
              <span className="min-w-0 leading-tight" data-id="element-195" data-mp="23npp40oqwuat">
                <span className="block font-heading text-[11px] font-extrabold uppercase text-navy" data-id="element-196" data-mp="2anjkzknjsh9x">{buyer.name}</span>
                <span className="block text-[10px] text-ink" data-id="element-197" data-mp="2fm365iubhp18">{buyer.place}</span>
                <span className="mt-1 block text-[10.5px] font-semibold text-brand" data-id="element-198" data-mp="2knsgew9ptyo9">
                  Just purchased the Orthopedic &amp; Trauma Toolkit™
                </span>
                <span className="block font-heading text-[9.5px] font-extrabold uppercase text-goldDark" data-id="element-199" data-mp="1rylinzi35d42">
                  {buyer.minutes} minutes ago
                </span>
              </span>
            </a>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Close notification" className="absolute -right-2 -top-2 flex h-5 w-5 items-center justify-center rounded-full border border-gold/50 bg-white text-navy" data-id="element-200" data-mp="21vzshg9i73ne">
              <XIcon className="h-3 w-3" strokeWidth={3} data-id="element-201" data-mp="1e5nafckjnqj3" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}